import { useTranslation } from 'react-i18n-lite'

import { AreaLine, SaveButton, Title } from './EditTools.styles'
import iconTools from 'shared/assets/img/tools.svg'

interface SectionDividerProps {
  onSave: () => void
}

const SectionDivider = ({ onSave }: SectionDividerProps) => {
  const { t } = useTranslation()
  return (
    <AreaLine>
      <Title>
        <img src={iconTools} alt={t('edit-tools.title')} />
        <h1>{t('edit-tools.title')}</h1>
      </Title>
      <SaveButton onClick={onSave} heightClass='semiSmall'>
        {t('edit-tools.save')}
      </SaveButton>
    </AreaLine>
  )
}

export default SectionDivider
